import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
export * from './carbon-icons-list';
import * as icons from './carbon-icons-list';
export default (function () {
  return Object.keys(icons).map(function (key) {
    return icons[key];
  });
})();